import { createContext } from "react";

/**
 * true once the intro curtain starts lifting — the hero uses this to begin
 * its entrance so the two animations overlap instead of running blind.
 * Defaults to true so any page without an intro just renders normally.
 */
export const IntroContext = createContext(true);
